module.exports = __webpack_public_path__ + "mo/img/piece-22.4dc36a2b.svg";